import {getRumGlobal} from '../utils'

export * from './ErrorBoundary'
export * from './init'

export const {logError} = getRumGlobal() || {}
